var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.137 8.202C1.99 9.496 3.887 11.667 7 11.667s5.01-2.172 5.863-3.466a2.18 2.18 0 0 0 0-2.403C12.01 4.503 10.113 2.333 7 2.333s-5.01 2.17-5.863 3.465a2.18 2.18 0 0 0 0 2.404m.974-1.762c.724-1.097 2.322-2.94 4.89-2.94s4.164 1.843 4.888 2.94c.221.335.221.785 0 1.12C11.165 8.657 9.568 10.5 7 10.5S2.835 8.657 2.111 7.56a1.03 1.03 0 0 1 0-1.12M9.528 7a2.528 2.528 0 1 1-5.056 0 2.528 2.528 0 0 1 5.056 0",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpen;